module.exports = __webpack_public_path__ + "img/menuTopLogo.8efca398.png";